import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5febcc36 = () => interopDefault(import('../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _d2028a14 = () => interopDefault(import('../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _488b7f31 = () => interopDefault(import('../pages/bauma2022.vue' /* webpackChunkName: "pages/bauma2022" */))
const _ba78d82c = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _23ec5eb7 = () => interopDefault(import('../pages/case.vue' /* webpackChunkName: "pages/case" */))
const _250ac0e1 = () => interopDefault(import('../pages/charity.vue' /* webpackChunkName: "pages/charity" */))
const _afb0f0fe = () => interopDefault(import('../pages/city-and-guilds.vue' /* webpackChunkName: "pages/city-and-guilds" */))
const _14f479d3 = () => interopDefault(import('../pages/claas.vue' /* webpackChunkName: "pages/claas" */))
const _49f57bb6 = () => interopDefault(import('../pages/clearance.vue' /* webpackChunkName: "pages/clearance" */))
const _460466ff = () => interopDefault(import('../pages/conditions.vue' /* webpackChunkName: "pages/conditions" */))
const _65ce2369 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _10e697aa = () => interopDefault(import('../pages/cookie.vue' /* webpackChunkName: "pages/cookie" */))
const _041df75b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2bd0bd08 = () => interopDefault(import('../pages/densoair.vue' /* webpackChunkName: "pages/densoair" */))
const _11be0de0 = () => interopDefault(import('../pages/favorites.vue' /* webpackChunkName: "pages/favorites" */))
const _a1119f30 = () => interopDefault(import('../pages/fendt.vue' /* webpackChunkName: "pages/fendt" */))
const _084223b6 = () => interopDefault(import('../pages/hebonilube-automatic.vue' /* webpackChunkName: "pages/hebonilube-automatic" */))
const _3d2c0c4e = () => interopDefault(import('../pages/issuu-catalogue.vue' /* webpackChunkName: "pages/issuu-catalogue" */))
const _34be086a = () => interopDefault(import('../pages/jcb-agricultural.vue' /* webpackChunkName: "pages/jcb-agricultural" */))
const _32db1748 = () => interopDefault(import('../pages/jcb-construction.vue' /* webpackChunkName: "pages/jcb-construction" */))
const _3430b088 = () => interopDefault(import('../pages/john-deere.vue' /* webpackChunkName: "pages/john-deere" */))
const _99ad24aa = () => interopDefault(import('../pages/kubota.vue' /* webpackChunkName: "pages/kubota" */))
const _c0451202 = () => interopDefault(import('../pages/massey-ferguson.vue' /* webpackChunkName: "pages/massey-ferguson" */))
const _959c8468 = () => interopDefault(import('../pages/new-holland.vue' /* webpackChunkName: "pages/new-holland" */))
const _f32eb10a = () => interopDefault(import('../pages/new-products/index.vue' /* webpackChunkName: "pages/new-products/index" */))
const _ba2a4046 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _70cbefba = () => interopDefault(import('../pages/oem/index.vue' /* webpackChunkName: "pages/oem/index" */))
const _fd260b0c = () => interopDefault(import('../pages/oksys.vue' /* webpackChunkName: "pages/oksys" */))
const _747cb4e6 = () => interopDefault(import('../pages/oilcrossreference.vue' /* webpackChunkName: "pages/oilcrossreference" */))
const _6c27fdf2 = () => interopDefault(import('../pages/password-forgotten/index.vue' /* webpackChunkName: "pages/password-forgotten/index" */))
const _2554bb6a = () => interopDefault(import('../pages/poweredge.vue' /* webpackChunkName: "pages/poweredge" */))
const _860ba25e = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _790b14a4 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _1e575c26 = () => interopDefault(import('../pages/john-deere-tractor.vue' /* webpackChunkName: "pages/john-deere-tractor" */))
const _3e2f1aa4 = () => interopDefault(import('../pages/purecab-activated-carbon-filter.vue' /* webpackChunkName: "pages/purecab-activated-carbon-filter" */))
const _106fd378 = () => interopDefault(import('../pages/return-policy.vue' /* webpackChunkName: "pages/return-policy" */))
const _5e72ee16 = () => interopDefault(import('../pages/sanden-compressors.vue' /* webpackChunkName: "pages/sanden-compressors" */))
const _37d88ec2 = () => interopDefault(import('../pages/schaeffler-belts.vue' /* webpackChunkName: "pages/schaeffler-belts" */))
const _68496d40 = () => interopDefault(import('../pages/sds-sheets-en.vue' /* webpackChunkName: "pages/sds-sheets-en" */))
const _493244b2 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _6ad6fc4e = () => interopDefault(import('../pages/spal-blower-motors.vue' /* webpackChunkName: "pages/spal-blower-motors" */))
const _a28e8492 = () => interopDefault(import('../pages/spal-condenser.vue' /* webpackChunkName: "pages/spal-condenser" */))
const _40211872 = () => interopDefault(import('../pages/special-offers.vue' /* webpackChunkName: "pages/special-offers" */))
const _d8c039c2 = () => interopDefault(import('../pages/tba-terms-conditions.vue' /* webpackChunkName: "pages/tba-terms-conditions" */))
const _8851e1fa = () => interopDefault(import('../pages/warranty.vue' /* webpackChunkName: "pages/warranty" */))
const _230791e5 = () => interopDefault(import('../pages/warranty-forms.vue' /* webpackChunkName: "pages/warranty-forms" */))
const _0e471bc2 = () => interopDefault(import('../pages/cart/data.vue' /* webpackChunkName: "pages/cart/data" */))
const _32ec9bc0 = () => interopDefault(import('../pages/cart/error.vue' /* webpackChunkName: "pages/cart/error" */))
const _a512c256 = () => interopDefault(import('../pages/cart/failed.vue' /* webpackChunkName: "pages/cart/failed" */))
const _63665b8d = () => interopDefault(import('../pages/cart/thankyou.vue' /* webpackChunkName: "pages/cart/thankyou" */))
const _581a3c53 = () => interopDefault(import('../pages/dev/test.vue' /* webpackChunkName: "pages/dev/test" */))
const _03716472 = () => interopDefault(import('../pages/search/SearchResultsProducts.vue' /* webpackChunkName: "pages/search/SearchResultsProducts" */))
const _4dfc8055 = () => interopDefault(import('../pages/search/SearchResultsVehicles.vue' /* webpackChunkName: "pages/search/SearchResultsVehicles" */))
const _bd9782d6 = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _35cfc64c = () => interopDefault(import('../pages/new-products/_product/index.vue' /* webpackChunkName: "pages/new-products/_product/index" */))
const _ed32fb52 = () => interopDefault(import('../pages/oem/_oem.vue' /* webpackChunkName: "pages/oem/_oem" */))
const _34882f0d = () => interopDefault(import('../pages/password-forgotten/_token/index.vue' /* webpackChunkName: "pages/password-forgotten/_token/index" */))
const _7b2d49d7 = () => interopDefault(import('../pages/product/_product.vue' /* webpackChunkName: "pages/product/_product" */))
const _72d8ce52 = () => interopDefault(import('../pages/products/_group/index.vue' /* webpackChunkName: "pages/products/_group/index" */))
const _8ad324fa = () => interopDefault(import('../pages/search/_product/index.vue' /* webpackChunkName: "pages/search/_product/index" */))
const _3485f096 = () => interopDefault(import('../pages/products/_group/_brand/index.vue' /* webpackChunkName: "pages/products/_group/_brand/index" */))
const _efe3bdc0 = () => interopDefault(import('../pages/products/_group/_brand/_type/index.vue' /* webpackChunkName: "pages/products/_group/_brand/_type/index" */))
const _591c414f = () => interopDefault(import('../pages/products/_group/_brand/_type/_model/index.vue' /* webpackChunkName: "pages/products/_group/_brand/_type/_model/index" */))
const _c59b5cf4 = () => interopDefault(import('../pages/products/_group/_brand/_type/_model/_product/index.vue' /* webpackChunkName: "pages/products/_group/_brand/_type/_model/_product/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _5febcc36,
    name: "about-us___en"
  }, {
    path: "/account",
    component: _d2028a14,
    name: "account___en"
  }, {
    path: "/bauma-2022",
    component: _488b7f31,
    name: "bauma2022___en"
  }, {
    path: "/cart",
    component: _ba78d82c,
    name: "cart___en"
  }, {
    path: "/case",
    component: _23ec5eb7,
    name: "case___en"
  }, {
    path: "/charity-and-sponsorship",
    component: _250ac0e1,
    name: "charity___en"
  }, {
    path: "/city-and-guilds",
    component: _afb0f0fe,
    name: "city-and-guilds___en"
  }, {
    path: "/claas",
    component: _14f479d3,
    name: "claas___en"
  }, {
    path: "/clearance",
    component: _49f57bb6,
    name: "clearance___en"
  }, {
    path: "/conditions",
    component: _460466ff,
    name: "conditions___en"
  }, {
    path: "/contact",
    component: _65ce2369,
    name: "contact___en"
  }, {
    path: "/cookie",
    component: _10e697aa,
    name: "cookie___en"
  }, {
    path: "/de",
    component: _041df75b,
    name: "index___de"
  }, {
    path: "/denso-air-conditioning-compressors",
    component: _2bd0bd08,
    name: "densoair___en"
  }, {
    path: "/favourites",
    component: _11be0de0,
    name: "favorites___en"
  }, {
    path: "/fendt",
    component: _a1119f30,
    name: "fendt___en"
  }, {
    path: "/fr",
    component: _041df75b,
    name: "index___fr"
  }, {
    path: "/hebonilube-automatic-grease-pumps",
    component: _084223b6,
    name: "hebonilube-automatic___en"
  }, {
    path: "/ie",
    component: _041df75b,
    name: "index___ie"
  }, {
    path: "/issuu-catalogue",
    component: _3d2c0c4e,
    name: "issuu-catalogue___en"
  }, {
    path: "/jcb-agricultural",
    component: _34be086a,
    name: "jcb-agricultural___en"
  }, {
    path: "/jcb-construction",
    component: _32db1748,
    name: "jcb-construction___en"
  }, {
    path: "/john-deere",
    component: _3430b088,
    name: "john-deere___en"
  }, {
    path: "/kubota",
    component: _99ad24aa,
    name: "kubota___en"
  }, {
    path: "/massey-ferguson",
    component: _c0451202,
    name: "massey-ferguson___en"
  }, {
    path: "/new-holland",
    component: _959c8468,
    name: "new-holland___en"
  }, {
    path: "/new-products",
    component: _f32eb10a,
    name: "new-products___en"
  }, {
    path: "/news",
    component: _ba2a4046,
    name: "news___en"
  }, {
    path: "/oem",
    component: _70cbefba,
    name: "oem___en"
  }, {
    path: "/oksys-r134a-service-machines",
    component: _fd260b0c,
    name: "oksys___en"
  }, {
    path: "/pag-oil-cross-reference-chart",
    component: _747cb4e6,
    name: "oilcrossreference___en"
  }, {
    path: "/password-forgotten",
    component: _6c27fdf2,
    name: "password-forgotten___en"
  }, {
    path: "/poweredge",
    component: _2554bb6a,
    name: "poweredge___en"
  }, {
    path: "/privacy",
    component: _860ba25e,
    name: "privacy___en"
  }, {
    path: "/products",
    component: _790b14a4,
    name: "products___en"
  }, {
    path: "/products-john-deere-tractor-parts",
    component: _1e575c26,
    name: "john-deere-tractor___en"
  }, {
    path: "/purecab-activated-carbon-filter",
    component: _3e2f1aa4,
    name: "purecab-activated-carbon-filter___en"
  }, {
    path: "/return-policy",
    component: _106fd378,
    name: "return-policy___en"
  }, {
    path: "/sanden-air-conditioning-compressors",
    component: _5e72ee16,
    name: "sanden-compressors___en"
  }, {
    path: "/schaeffler-belts-oaps-and-fead-kits",
    component: _37d88ec2,
    name: "schaeffler-belts___en"
  }, {
    path: "/sds-sheets-en",
    component: _68496d40,
    name: "sds-sheets-en___en"
  }, {
    path: "/search",
    component: _493244b2,
    name: "search___en"
  }, {
    path: "/spal-blower-motors",
    component: _6ad6fc4e,
    name: "spal-blower-motors___en"
  }, {
    path: "/spal-condenser-fans",
    component: _a28e8492,
    name: "spal-condenser___en"
  }, {
    path: "/special-offers",
    component: _40211872,
    name: "special-offers___en"
  }, {
    path: "/tba-terms-and-conditions",
    component: _d8c039c2,
    name: "tba-terms-conditions___en"
  }, {
    path: "/warranty",
    component: _8851e1fa,
    name: "warranty___en"
  }, {
    path: "/warranty-forms",
    component: _230791e5,
    name: "warranty-forms___en"
  }, {
    path: "/cart/data",
    component: _0e471bc2,
    name: "cart-data___en"
  }, {
    path: "/cart/error",
    component: _32ec9bc0,
    name: "cart-error___en"
  }, {
    path: "/cart/failed",
    component: _a512c256,
    name: "cart-failed___en"
  }, {
    path: "/cart/thank-you",
    component: _63665b8d,
    name: "cart-thankyou___en"
  }, {
    path: "/de/bauma-2022",
    component: _488b7f31,
    name: "bauma2022___de"
  }, {
    path: "/de/bedingungen",
    component: _460466ff,
    name: "conditions___de"
  }, {
    path: "/de/case",
    component: _23ec5eb7,
    name: "case___de"
  }, {
    path: "/de/charity-and-sponsorship",
    component: _250ac0e1,
    name: "charity___de"
  }, {
    path: "/de/city-and-guilds",
    component: _afb0f0fe,
    name: "city-and-guilds___de"
  }, {
    path: "/de/claas",
    component: _14f479d3,
    name: "claas___de"
  }, {
    path: "/de/clearance",
    component: _49f57bb6,
    name: "clearance___de"
  }, {
    path: "/de/cookie",
    component: _10e697aa,
    name: "cookie___de"
  }, {
    path: "/de/denso-air-conditioning-compressors",
    component: _2bd0bd08,
    name: "densoair___de"
  }, {
    path: "/de/favourites",
    component: _11be0de0,
    name: "favorites___de"
  }, {
    path: "/de/fendt",
    component: _a1119f30,
    name: "fendt___de"
  }, {
    path: "/de/garantie",
    component: _8851e1fa,
    name: "warranty___de"
  }, {
    path: "/de/hebonilube-automatic-grease-pumps",
    component: _084223b6,
    name: "hebonilube-automatic___de"
  }, {
    path: "/de/issuu-catalogue",
    component: _3d2c0c4e,
    name: "issuu-catalogue___de"
  }, {
    path: "/de/jcb-agricultural",
    component: _34be086a,
    name: "jcb-agricultural___de"
  }, {
    path: "/de/jcb-construction",
    component: _32db1748,
    name: "jcb-construction___de"
  }, {
    path: "/de/john-deere",
    component: _3430b088,
    name: "john-deere___de"
  }, {
    path: "/de/kontakt",
    component: _65ce2369,
    name: "contact___de"
  }, {
    path: "/de/konto",
    component: _d2028a14,
    name: "account___de"
  }, {
    path: "/de/kubota",
    component: _99ad24aa,
    name: "kubota___de"
  }, {
    path: "/de/massey-ferguson",
    component: _c0451202,
    name: "massey-ferguson___de"
  }, {
    path: "/de/nachrichten",
    component: _ba2a4046,
    name: "news___de"
  }, {
    path: "/de/new-holland",
    component: _959c8468,
    name: "new-holland___de"
  }, {
    path: "/de/new-products",
    component: _f32eb10a,
    name: "new-products___de"
  }, {
    path: "/de/oem",
    component: _70cbefba,
    name: "oem___de"
  }, {
    path: "/de/oksys-r134a-service-machines",
    component: _fd260b0c,
    name: "oksys___de"
  }, {
    path: "/de/pag-oil-cross-reference-chart",
    component: _747cb4e6,
    name: "oilcrossreference___de"
  }, {
    path: "/de/passwort-vergessen",
    component: _6c27fdf2,
    name: "password-forgotten___de"
  }, {
    path: "/de/poweredge",
    component: _2554bb6a,
    name: "poweredge___de"
  }, {
    path: "/de/privacy",
    component: _860ba25e,
    name: "privacy___de"
  }, {
    path: "/de/products-john-deere-tractor-parts",
    component: _1e575c26,
    name: "john-deere-tractor___de"
  }, {
    path: "/de/produkte",
    component: _790b14a4,
    name: "products___de"
  }, {
    path: "/de/purecab-activated-carbon-filter",
    component: _3e2f1aa4,
    name: "purecab-activated-carbon-filter___de"
  }, {
    path: "/de/ruecknahmegarantie",
    component: _106fd378,
    name: "return-policy___de"
  }, {
    path: "/de/sanden-air-conditioning-compressors",
    component: _5e72ee16,
    name: "sanden-compressors___de"
  }, {
    path: "/de/schaeffler-belts-oaps-and-fead-kits",
    component: _37d88ec2,
    name: "schaeffler-belts___de"
  }, {
    path: "/de/sds-sheets-en",
    component: _68496d40,
    name: "sds-sheets-en___de"
  }, {
    path: "/de/spal-blower-motors",
    component: _6ad6fc4e,
    name: "spal-blower-motors___de"
  }, {
    path: "/de/spal-condenser-fans",
    component: _a28e8492,
    name: "spal-condenser___de"
  }, {
    path: "/de/special-offers",
    component: _40211872,
    name: "special-offers___de"
  }, {
    path: "/de/suechen",
    component: _493244b2,
    name: "search___de"
  }, {
    path: "/de/tba-terms-and-conditions",
    component: _d8c039c2,
    name: "tba-terms-conditions___de"
  }, {
    path: "/de/ueber-uns",
    component: _5febcc36,
    name: "about-us___de"
  }, {
    path: "/de/warenkorb",
    component: _ba78d82c,
    name: "cart___de"
  }, {
    path: "/de/warranty-forms",
    component: _230791e5,
    name: "warranty-forms___de"
  }, {
    path: "/dev/test",
    component: _581a3c53,
    name: "dev-test___en"
  }, {
    path: "/fr/a-propos-de-nous",
    component: _5febcc36,
    name: "about-us___fr"
  }, {
    path: "/fr/actualites",
    component: _ba2a4046,
    name: "news___fr"
  }, {
    path: "/fr/bauma-2022",
    component: _488b7f31,
    name: "bauma2022___fr"
  }, {
    path: "/fr/case",
    component: _23ec5eb7,
    name: "case___fr"
  }, {
    path: "/fr/charity-and-sponsorship",
    component: _250ac0e1,
    name: "charity___fr"
  }, {
    path: "/fr/city-and-guilds",
    component: _afb0f0fe,
    name: "city-and-guilds___fr"
  }, {
    path: "/fr/claas",
    component: _14f479d3,
    name: "claas___fr"
  }, {
    path: "/fr/clearance",
    component: _49f57bb6,
    name: "clearance___fr"
  }, {
    path: "/fr/compte",
    component: _d2028a14,
    name: "account___fr"
  }, {
    path: "/fr/conditions",
    component: _460466ff,
    name: "conditions___fr"
  }, {
    path: "/fr/contact",
    component: _65ce2369,
    name: "contact___fr"
  }, {
    path: "/fr/cookie",
    component: _10e697aa,
    name: "cookie___fr"
  }, {
    path: "/fr/denso-air-conditioning-compressors",
    component: _2bd0bd08,
    name: "densoair___fr"
  }, {
    path: "/fr/favourites",
    component: _11be0de0,
    name: "favorites___fr"
  }, {
    path: "/fr/fendt",
    component: _a1119f30,
    name: "fendt___fr"
  }, {
    path: "/fr/garantie",
    component: _8851e1fa,
    name: "warranty___fr"
  }, {
    path: "/fr/hebonilube-automatic-grease-pumps",
    component: _084223b6,
    name: "hebonilube-automatic___fr"
  }, {
    path: "/fr/issuu-catalogue",
    component: _3d2c0c4e,
    name: "issuu-catalogue___fr"
  }, {
    path: "/fr/jcb-agricultural",
    component: _34be086a,
    name: "jcb-agricultural___fr"
  }, {
    path: "/fr/jcb-construction",
    component: _32db1748,
    name: "jcb-construction___fr"
  }, {
    path: "/fr/john-deere",
    component: _3430b088,
    name: "john-deere___fr"
  }, {
    path: "/fr/kubota",
    component: _99ad24aa,
    name: "kubota___fr"
  }, {
    path: "/fr/massey-ferguson",
    component: _c0451202,
    name: "massey-ferguson___fr"
  }, {
    path: "/fr/mot-de-passe-oublie",
    component: _6c27fdf2,
    name: "password-forgotten___fr"
  }, {
    path: "/fr/new-holland",
    component: _959c8468,
    name: "new-holland___fr"
  }, {
    path: "/fr/new-products",
    component: _f32eb10a,
    name: "new-products___fr"
  }, {
    path: "/fr/oem",
    component: _70cbefba,
    name: "oem___fr"
  }, {
    path: "/fr/oksys-r134a-service-machines",
    component: _fd260b0c,
    name: "oksys___fr"
  }, {
    path: "/fr/pag-oil-cross-reference-chart",
    component: _747cb4e6,
    name: "oilcrossreference___fr"
  }, {
    path: "/fr/panier",
    component: _ba78d82c,
    name: "cart___fr"
  }, {
    path: "/fr/politique-de-retour",
    component: _106fd378,
    name: "return-policy___fr"
  }, {
    path: "/fr/poweredge",
    component: _2554bb6a,
    name: "poweredge___fr"
  }, {
    path: "/fr/privacy",
    component: _860ba25e,
    name: "privacy___fr"
  }, {
    path: "/fr/products-john-deere-tractor-parts",
    component: _1e575c26,
    name: "john-deere-tractor___fr"
  }, {
    path: "/fr/produits",
    component: _790b14a4,
    name: "products___fr"
  }, {
    path: "/fr/purecab-activated-carbon-filter",
    component: _3e2f1aa4,
    name: "purecab-activated-carbon-filter___fr"
  }, {
    path: "/fr/rechercher",
    component: _493244b2,
    name: "search___fr"
  }, {
    path: "/fr/sanden-air-conditioning-compressors",
    component: _5e72ee16,
    name: "sanden-compressors___fr"
  }, {
    path: "/fr/schaeffler-belts-oaps-and-fead-kits",
    component: _37d88ec2,
    name: "schaeffler-belts___fr"
  }, {
    path: "/fr/sds-sheets-en",
    component: _68496d40,
    name: "sds-sheets-en___fr"
  }, {
    path: "/fr/spal-blower-motors",
    component: _6ad6fc4e,
    name: "spal-blower-motors___fr"
  }, {
    path: "/fr/spal-condenser-fans",
    component: _a28e8492,
    name: "spal-condenser___fr"
  }, {
    path: "/fr/special-offers",
    component: _40211872,
    name: "special-offers___fr"
  }, {
    path: "/fr/tba-terms-and-conditions",
    component: _d8c039c2,
    name: "tba-terms-conditions___fr"
  }, {
    path: "/fr/warranty-forms",
    component: _230791e5,
    name: "warranty-forms___fr"
  }, {
    path: "/ie/about-us",
    component: _5febcc36,
    name: "about-us___ie"
  }, {
    path: "/ie/account",
    component: _d2028a14,
    name: "account___ie"
  }, {
    path: "/ie/bauma-2022",
    component: _488b7f31,
    name: "bauma2022___ie"
  }, {
    path: "/ie/cart",
    component: _ba78d82c,
    name: "cart___ie"
  }, {
    path: "/ie/case",
    component: _23ec5eb7,
    name: "case___ie"
  }, {
    path: "/ie/charity-and-sponsorship",
    component: _250ac0e1,
    name: "charity___ie"
  }, {
    path: "/ie/city-and-guilds",
    component: _afb0f0fe,
    name: "city-and-guilds___ie"
  }, {
    path: "/ie/claas",
    component: _14f479d3,
    name: "claas___ie"
  }, {
    path: "/ie/clearance",
    component: _49f57bb6,
    name: "clearance___ie"
  }, {
    path: "/ie/conditions",
    component: _460466ff,
    name: "conditions___ie"
  }, {
    path: "/ie/contact",
    component: _65ce2369,
    name: "contact___ie"
  }, {
    path: "/ie/cookie",
    component: _10e697aa,
    name: "cookie___ie"
  }, {
    path: "/ie/denso-air-conditioning-compressors",
    component: _2bd0bd08,
    name: "densoair___ie"
  }, {
    path: "/ie/favourites",
    component: _11be0de0,
    name: "favorites___ie"
  }, {
    path: "/ie/fendt",
    component: _a1119f30,
    name: "fendt___ie"
  }, {
    path: "/ie/hebonilube-automatic-grease-pumps",
    component: _084223b6,
    name: "hebonilube-automatic___ie"
  }, {
    path: "/ie/issuu-catalogue",
    component: _3d2c0c4e,
    name: "issuu-catalogue___ie"
  }, {
    path: "/ie/jcb-agricultural",
    component: _34be086a,
    name: "jcb-agricultural___ie"
  }, {
    path: "/ie/jcb-construction",
    component: _32db1748,
    name: "jcb-construction___ie"
  }, {
    path: "/ie/john-deere",
    component: _3430b088,
    name: "john-deere___ie"
  }, {
    path: "/ie/kubota",
    component: _99ad24aa,
    name: "kubota___ie"
  }, {
    path: "/ie/massey-ferguson",
    component: _c0451202,
    name: "massey-ferguson___ie"
  }, {
    path: "/ie/new-holland",
    component: _959c8468,
    name: "new-holland___ie"
  }, {
    path: "/ie/new-products",
    component: _f32eb10a,
    name: "new-products___ie"
  }, {
    path: "/ie/news",
    component: _ba2a4046,
    name: "news___ie"
  }, {
    path: "/ie/oem",
    component: _70cbefba,
    name: "oem___ie"
  }, {
    path: "/ie/oksys-r134a-service-machines",
    component: _fd260b0c,
    name: "oksys___ie"
  }, {
    path: "/ie/pag-oil-cross-reference-chart",
    component: _747cb4e6,
    name: "oilcrossreference___ie"
  }, {
    path: "/ie/password-forgotten",
    component: _6c27fdf2,
    name: "password-forgotten___ie"
  }, {
    path: "/ie/poweredge",
    component: _2554bb6a,
    name: "poweredge___ie"
  }, {
    path: "/ie/privacy",
    component: _860ba25e,
    name: "privacy___ie"
  }, {
    path: "/ie/products",
    component: _790b14a4,
    name: "products___ie"
  }, {
    path: "/ie/products-john-deere-tractor-parts",
    component: _1e575c26,
    name: "john-deere-tractor___ie"
  }, {
    path: "/ie/purecab-activated-carbon-filter",
    component: _3e2f1aa4,
    name: "purecab-activated-carbon-filter___ie"
  }, {
    path: "/ie/return-policy",
    component: _106fd378,
    name: "return-policy___ie"
  }, {
    path: "/ie/sanden-air-conditioning-compressors",
    component: _5e72ee16,
    name: "sanden-compressors___ie"
  }, {
    path: "/ie/schaeffler-belts-oaps-and-fead-kits",
    component: _37d88ec2,
    name: "schaeffler-belts___ie"
  }, {
    path: "/ie/sds-sheets-en",
    component: _68496d40,
    name: "sds-sheets-en___ie"
  }, {
    path: "/ie/search",
    component: _493244b2,
    name: "search___ie"
  }, {
    path: "/ie/spal-blower-motors",
    component: _6ad6fc4e,
    name: "spal-blower-motors___ie"
  }, {
    path: "/ie/spal-condenser-fans",
    component: _a28e8492,
    name: "spal-condenser___ie"
  }, {
    path: "/ie/special-offers",
    component: _40211872,
    name: "special-offers___ie"
  }, {
    path: "/ie/tba-terms-and-conditions",
    component: _d8c039c2,
    name: "tba-terms-conditions___ie"
  }, {
    path: "/ie/warranty",
    component: _8851e1fa,
    name: "warranty___ie"
  }, {
    path: "/ie/warranty-forms",
    component: _230791e5,
    name: "warranty-forms___ie"
  }, {
    path: "/search/SearchResultsProducts",
    component: _03716472,
    name: "search-SearchResultsProducts___en"
  }, {
    path: "/search/SearchResultsVehicles",
    component: _4dfc8055,
    name: "search-SearchResultsVehicles___en"
  }, {
    path: "/de/cart/error",
    component: _32ec9bc0,
    name: "cart-error___de"
  }, {
    path: "/de/dev/test",
    component: _581a3c53,
    name: "dev-test___de"
  }, {
    path: "/de/search/SearchResultsProducts",
    component: _03716472,
    name: "search-SearchResultsProducts___de"
  }, {
    path: "/de/search/SearchResultsVehicles",
    component: _4dfc8055,
    name: "search-SearchResultsVehicles___de"
  }, {
    path: "/de/warenkorb/dankr",
    component: _63665b8d,
    name: "cart-thankyou___de"
  }, {
    path: "/de/warenkorb/data",
    component: _0e471bc2,
    name: "cart-data___de"
  }, {
    path: "/de/warenkorb/error",
    component: _a512c256,
    name: "cart-failed___de"
  }, {
    path: "/fr/cart/error",
    component: _32ec9bc0,
    name: "cart-error___fr"
  }, {
    path: "/fr/dev/test",
    component: _581a3c53,
    name: "dev-test___fr"
  }, {
    path: "/fr/panier/data",
    component: _0e471bc2,
    name: "cart-data___fr"
  }, {
    path: "/fr/panier/failed",
    component: _a512c256,
    name: "cart-failed___fr"
  }, {
    path: "/fr/panier/thank-you",
    component: _63665b8d,
    name: "cart-thankyou___fr"
  }, {
    path: "/fr/search/SearchResultsProducts",
    component: _03716472,
    name: "search-SearchResultsProducts___fr"
  }, {
    path: "/fr/search/SearchResultsVehicles",
    component: _4dfc8055,
    name: "search-SearchResultsVehicles___fr"
  }, {
    path: "/ie/cart/data",
    component: _0e471bc2,
    name: "cart-data___ie"
  }, {
    path: "/ie/cart/error",
    component: _32ec9bc0,
    name: "cart-error___ie"
  }, {
    path: "/ie/cart/failed",
    component: _a512c256,
    name: "cart-failed___ie"
  }, {
    path: "/ie/cart/thank-you",
    component: _63665b8d,
    name: "cart-thankyou___ie"
  }, {
    path: "/ie/dev/test",
    component: _581a3c53,
    name: "dev-test___ie"
  }, {
    path: "/ie/search/SearchResultsProducts",
    component: _03716472,
    name: "search-SearchResultsProducts___ie"
  }, {
    path: "/ie/search/SearchResultsVehicles",
    component: _4dfc8055,
    name: "search-SearchResultsVehicles___ie"
  }, {
    path: "/de/nachrichten/:slug",
    component: _bd9782d6,
    name: "news-slug___de"
  }, {
    path: "/de/new-products/:product",
    component: _35cfc64c,
    name: "new-products-product___de"
  }, {
    path: "/de/oem/:oemNumber",
    component: _ed32fb52,
    name: "oem-oem___de"
  }, {
    path: "/de/passwort-vergessen/:token",
    component: _34882f0d,
    name: "password-forgotten-token___de"
  }, {
    path: "/de/produkt/:product",
    component: _7b2d49d7,
    name: "product-product___de"
  }, {
    path: "/de/produkte/:group",
    component: _72d8ce52,
    name: "products-group___de"
  }, {
    path: "/de/suechen/:product",
    component: _8ad324fa,
    name: "search-product___de"
  }, {
    path: "/fr/actualites/:slug",
    component: _bd9782d6,
    name: "news-slug___fr"
  }, {
    path: "/fr/mot-de-passe-oublie/:token",
    component: _34882f0d,
    name: "password-forgotten-token___fr"
  }, {
    path: "/fr/new-products/:product",
    component: _35cfc64c,
    name: "new-products-product___fr"
  }, {
    path: "/fr/oem/:oemNumber",
    component: _ed32fb52,
    name: "oem-oem___fr"
  }, {
    path: "/fr/produit/:product",
    component: _7b2d49d7,
    name: "product-product___fr"
  }, {
    path: "/fr/produits/:group",
    component: _72d8ce52,
    name: "products-group___fr"
  }, {
    path: "/fr/rechercher/:product",
    component: _8ad324fa,
    name: "search-product___fr"
  }, {
    path: "/ie/new-products/:product",
    component: _35cfc64c,
    name: "new-products-product___ie"
  }, {
    path: "/ie/news/:slug",
    component: _bd9782d6,
    name: "news-slug___ie"
  }, {
    path: "/ie/oem/:oemNumber",
    component: _ed32fb52,
    name: "oem-oem___ie"
  }, {
    path: "/ie/password-forgotten/:token",
    component: _34882f0d,
    name: "password-forgotten-token___ie"
  }, {
    path: "/ie/product/:product",
    component: _7b2d49d7,
    name: "product-product___ie"
  }, {
    path: "/ie/products/:group",
    component: _72d8ce52,
    name: "products-group___ie"
  }, {
    path: "/ie/search/:product",
    component: _8ad324fa,
    name: "search-product___ie"
  }, {
    path: "/de/produkte/:group/:brand",
    component: _3485f096,
    name: "products-group-brand___de"
  }, {
    path: "/fr/produits/:group/:brand",
    component: _3485f096,
    name: "products-group-brand___fr"
  }, {
    path: "/ie/products/:group/:brand",
    component: _3485f096,
    name: "products-group-brand___ie"
  }, {
    path: "/de/produkte/:group/:brand/:type",
    component: _efe3bdc0,
    name: "products-group-brand-type___de"
  }, {
    path: "/fr/produits/:group/:brand/:type",
    component: _efe3bdc0,
    name: "products-group-brand-type___fr"
  }, {
    path: "/ie/products/:group/:brand/:type",
    component: _efe3bdc0,
    name: "products-group-brand-type___ie"
  }, {
    path: "/de/produkte/:group/:brand/:type/:model",
    component: _591c414f,
    name: "products-group-brand-type-model___de"
  }, {
    path: "/fr/produits/:group/:brand/:type/:model",
    component: _591c414f,
    name: "products-group-brand-type-model___fr"
  }, {
    path: "/ie/products/:group/:brand/:type/:model",
    component: _591c414f,
    name: "products-group-brand-type-model___ie"
  }, {
    path: "/de/produkte/:group/:brand/:type/:model/:product",
    component: _c59b5cf4,
    name: "products-group-brand-type-model-product___de"
  }, {
    path: "/fr/produits/:group/:brand/:type/:model/:product",
    component: _c59b5cf4,
    name: "products-group-brand-type-model-product___fr"
  }, {
    path: "/ie/products/:group/:brand/:type/:model/:product",
    component: _c59b5cf4,
    name: "products-group-brand-type-model-product___ie"
  }, {
    path: "/new-products/:product",
    component: _35cfc64c,
    name: "new-products-product___en"
  }, {
    path: "/news/:slug",
    component: _bd9782d6,
    name: "news-slug___en"
  }, {
    path: "/oem/:oemNumber",
    component: _ed32fb52,
    name: "oem-oem___en"
  }, {
    path: "/password-forgotten/:token",
    component: _34882f0d,
    name: "password-forgotten-token___en"
  }, {
    path: "/product/:product",
    component: _7b2d49d7,
    name: "product-product___en"
  }, {
    path: "/products/:group",
    component: _72d8ce52,
    name: "products-group___en"
  }, {
    path: "/search/:product",
    component: _8ad324fa,
    name: "search-product___en"
  }, {
    path: "/products/:group/:brand",
    component: _3485f096,
    name: "products-group-brand___en"
  }, {
    path: "/products/:group/:brand/:type",
    component: _efe3bdc0,
    name: "products-group-brand-type___en"
  }, {
    path: "/products/:group/:brand/:type/:model",
    component: _591c414f,
    name: "products-group-brand-type-model___en"
  }, {
    path: "/products/:group/:brand/:type/:model/:product",
    component: _c59b5cf4,
    name: "products-group-brand-type-model-product___en"
  }, {
    path: "/",
    component: _041df75b,
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
